
import "./CraeteUser.css";
import React, { useState } from "react";
import { teamType, ProjectRoleType } from "../../interfaces";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context";
import { createUser } from "../../api";
import Header from "../../Components/Header/Header";
import ProjectAndRole from "./ProjectAndRole";
import Loading from "../../Components/Loading/Loading";
import StarRateIcon from "@mui/icons-material/StarRate";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

type permissionType = {
    id?: number,
    project: string | undefined,
    role: string | undefined,
}

function CreateUser() {

    const {
        teamData,
        setTeamData,
        projectType,
        setProjectType,
        setLoading
    } = useGlobalContext()

    const navigate = useNavigate();
    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [showPass, setShowPass] = useState<boolean>(false);
    const [pinCode, setPinCode] = useState<string>("");
    const [errorData, setErrorData] = useState<boolean>(false);

    const goToUserPage = () => {
        navigate("/employees");
    }

    const handleClick = (item: teamType): void => {
        setTeamData((teamData: teamType[]) => teamData.map((team: teamType) => team.id === item.id ? { ...team, active: !team.active } : { ...team }));
    }

    const userTeamDataUpdate = (): string[] => {
         let departaments = new Array<string>();
         teamData.forEach((item: teamType) => {
             if (item.active) {
                 departaments.push(item.title);
             }
         })
        return departaments;
    }

    const userProfileTypeDataUpdate = (): permissionType[] => {
        let permissions = new Array<permissionType>();
        projectType.forEach((item: ProjectRoleType) => {
            let obj: permissionType = {
                project: item.projects.find(proj => proj.active)?.text,
                role: item.roles.find(role => role.active)?.title.toUpperCase()
            }
            permissions.push(obj);
        })
        return permissions;
    }

    const checkRequestData = (): void => {
        if (name && email && password && pinCode && userTeamDataUpdate().length > 0 && userProfileTypeDataUpdate()[0].role && userProfileTypeDataUpdate()[0].project) {
            setErrorData(false);
            createUserRequest().then(r => r);
        }
        else {
            setErrorData(true);
        }
    }

    const clearData = () => {
        setName("");
        setEmail("");
        setPassword("");
        setPinCode("");
        setErrorData(false);
        setShowPass(false);
        setTeamData((teamData: teamType[]) => teamData.map((team: teamType) => { return { ...team, active: false } }));
        setProjectType([
            {
                id: 1,
                isOpenProjects: false,
                isOpenRoles: false,
                projects: [
                    {
                        id: 1,
                        title: "Project X",
                        text: "PX",
                        active: false
                    },
                    {
                        id: 2,
                        title: "Billing Sheet",
                        text: "BS",
                        active: false
                    },
                    {
                        id: 3,
                        title: "Flyer Maker",
                        text: "FM",
                        active: false
                    },
                    {
                        id: 4,
                        title: "Video Maker",
                        text: "VM",
                        active: false
                    },
                    {
                        id: 5,
                        title: "Cover Maker",
                        text: "CM",
                        active: false
                    },
                    {
                        id: 6,
                        title: "QR Code",
                        text: "QR",
                        active: false
                    },
                    {
                        id: 7,
                        title: "Linkedin",
                        text: "IN",
                        active: false
                    },
                    {
                        id: 8,
                        title: "Meta Post",
                        text: "MP",
                        active: false
                    },
                    {
                        id: 9,
                        title: "Auto Posting",
                        text: "AP",
                        active: false
                    },
                    {
                        id: 10,
                        title: "Ad Campaign",
                        text: "AC",
                        active: false
                    },
                    {
                        id: 11,
                        title: "Jotform",
                        text: "JF",
                        active: false
                    },
                    {
                        id: 12,
                        title: "Lead Center",
                        text: "LC",
                        active: false
                    },
                    {
                        id: 13,
                        title: "Sales Sheet",
                        text: "SS",
                        active: false
                    },
                    {
                        id: 14,
                        title: "Complaints Sheet",
                        text: "CS",
                        active: false
                    },
                    {
                        id: 15,
                        title: "Timekeeper",
                        text: "TK",
                        active: false
                    },
                    {
                        id: 16,
                        title: "Generic Forms",
                        text: "GF",
                        active: false
                    },
                    {
                        id: 17,
                        title: "SSL Tracker",
                        text: "ST",
                        active: false
                    },
                    {
                        id: 18,
                        title: "Lead Generation Center",
                        text: "LCT",
                        active: false
                    },
                    {
                        id: 19,
                        title: "Voice Campaign",
                        text: "VC",
                        active: false
                    },
                    {
                        id: 20,
                        title: "Commission Hub",
                        text: "CH",
                        active: false
                    },
                    {
                        id: 21,
                        title: "Article Generation",
                        text: "AG",
                        active: false
                    }
                ],
                roles:[
                    {
                        id: 1,
                        title: "Admin",
                        active: false
                    },
                    {
                        id: 2,
                        title: "Moderator",
                        active: false
                    },
                    {
                        id: 3,
                        title: "User",
                        active: false
                    },
                ]
            }
        ]);
    }

    const createUserRequest = async (): Promise<void> => {
        setLoading(true);
        const requestData = {
            fullName: name,
            username: email,
            password: password,
            permissions: userProfileTypeDataUpdate(),
            departments: userTeamDataUpdate(),
            pinCode: pinCode
        }
        try {
            const responseData = await createUser(requestData);
            if (responseData) {
                clearData();
                navigate("/employees");
            }
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
    }

    // @ts-ignore
    return (
        <div className = "CraeteUser">
            <Header/>
            <div className = "allClients-container">
                <div className = "allClients-header" style = {{ marginBottom: "50px" }}>
                    <div className = "allClients-header-heading">
                        <h2>CREATE USER</h2>
                    </div>
                    <div className = "allClients-header-btns">
                        <button
                            onClick = { goToUserPage }
                        >
                            Users
                        </button>
                    </div>
                </div>
                <div className = "createClient-form">
                    <div className = "createClient-form-type mrg-btm">
                        <div className = "form-type-box">
                            <label>
                                Name
                                <StarRateIcon
                                    style = {{ color: "red", fontSize: "10px" }}
                                />
                            </label>
                        </div>
                        <div className = "form-type-box">
                            <input
                                className = "type-box-type-input"
                                type = "text"
                                value = { name }
                                onChange = {e => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className = "createClient-form-type mrg-btm">
                        <div className = "form-type-box">
                            <label>
                                Email
                                <StarRateIcon
                                    style = {{ color: "red", fontSize: "10px" }}
                                />
                            </label>
                        </div>
                        <div className = "form-type-box">
                            <input
                                className = "type-box-type-input"
                                type = "text"
                                value = { email }
                                onChange = { e => setEmail(e.target.value) }
                                readOnly
                                onFocus = {(e) => e.target.removeAttribute("readOnly")}
                            />
                        </div>
                    </div>
                    <div className = "createClient-form-type mrg-btm">
                        <div className = "form-type-box">
                            <label>
                                Password
                                <StarRateIcon
                                    style = {{ color: "red", fontSize: "10px" }}
                                />
                            </label>
                        </div>
                        <div className="form-type-box">
                            <input
                                className = "type-box-type-input"
                                type = { showPass ? "text" : "password" }
                                value = { password }
                                onChange = {e => setPassword(e.target.value)}
                                readOnly
                                onFocus = {(e) => e.target.removeAttribute("readOnly")}
                            />
                            {
                                showPass ?
                                    <VisibilityOffIcon
                                        className = "showPass"
                                        onClick = {() => setShowPass(false)}
                                    />
                                    :
                                    <RemoveRedEyeIcon
                                        className = "hidePass"
                                        onClick = {() => setShowPass(true)}
                                    />
                            }
                        </div>
                    </div>
                    <div className = "createClient-form-type mrg-btm">
                        <div className = "form-type-box">
                            <label>Team <StarRateIcon style = {{ color: "red", fontSize: "10px" }}/> </label>
                        </div>
                        <div className = "form-type-box user-team-box">
                            {
                                teamData.map((item: teamType, index: number) =>
                                    <span>
                                        <input
                                            type = "checkbox"
                                            checked = { item.active }
                                            className = "team-checkbox"
                                            onClick = { () => handleClick(item) }
                                        />
                                        <label>{ item.text }</label>
                                    </span>
                                )
                            }
                        </div>
                    </div>
                    <ProjectAndRole/>
                    <div className = "createClient-form-type mrg-btm">
                        <div className = "form-type-box">
                            <label>Pin Code <StarRateIcon style = {{ color: "red", fontSize: "10px" }}/> </label>
                        </div>
                        <div className = "form-type-box">
                            <input
                                className = "type-box-type-input"
                                type = "text"
                                value = { pinCode }
                                onChange = { e => setPinCode(e.target.value) }
                            />
                        </div>
                    </div>
                </div>
                <div className = "createClient-submit-btn">
                    <span
                        style = {{
                            display: errorData ? "block" : "none"
                        }}
                    >
                        Invalid Information
                    </span>
                    <button
                        style = {{
                            cursor: "pointer",
                            backgroundColor: "#004DE7",
                            color: "white",
                        }}
                        onClick = { checkRequestData }
                    >
                        Save
                    </button>
                </div>
            </div>
            <Loading/>
        </div>
    )
}

export default CreateUser
